import { useState } from 'react';
import styled from 'styled-components';
import { Button, Layout, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Header } from '../layouts/Header';
import { Content } from '../layouts/Content';
import { MemberListTable } from '../components/Organization/MemberListTable';
import { InviteListTable } from '../components/Organization/InviteListTable';
import { CreateInvitationModal } from '../components/Organization/CreateInvitationModal';
import { EditMemberModal } from '../components/Organization/EditMemberModal';
import type { Member } from '../types/domain';
import { InfoAlert } from '../components/InfoAlert';
import { useTranslation } from 'react-i18next';

const Organization = () => {
  const { t } = useTranslation();

  const [isCreateInvitationModalVisible, setIsCreateInvitationModalVisible] =
    useState(false);
  const [isEditMemberModalVisible, setIsEditMemberModalVisible] =
    useState(false);
  const [selectedMember, setSelectedMember] = useState<Member>();

  return (
    <Layout>
      <Header />
      <Content isScrollable>
        <StyledSpace direction="vertical" size={18}>
          <PageTitle>{t('manageOrg')}</PageTitle>
          <Space direction="vertical" size={24}>
            <ContentHeading>{t('orgMemberList')}</ContentHeading>
            <InfoAlert
              showIcon
              message={t('message.memberInfoCannotBeModified')}
            />
            <MemberListTable
              onSelect={(member: Member): void => {
                setSelectedMember(member);
                setIsEditMemberModalVisible(true);
              }}
            />

            <Space size={12}>
              <ContentHeading>{t('invitingMembers')}</ContentHeading>
              <Button
                type="primary"
                size="small"
                shape="circle"
                icon={<PlusOutlined />}
                onClick={(): void => {
                  setIsCreateInvitationModalVisible(true);
                }}
              />
            </Space>

            <InviteListTable />
          </Space>
        </StyledSpace>
        <CreateInvitationModal
          isVisible={isCreateInvitationModalVisible}
          onClose={(): void => {
            setIsCreateInvitationModalVisible(false);
          }}
        />
        <EditMemberModal
          user={selectedMember}
          isVisible={isEditMemberModalVisible}
          onClose={(): void => {
            setIsEditMemberModalVisible(false);
          }}
        />
      </Content>
    </Layout>
  );
};

const StyledSpace = styled(Space)`
  padding: 35px 31px;
`;

const PageTitle = styled.div`
  font: normal normal normal 34px/46px Segoe UI;
  margin-bottom: 16px;
`;

const ContentHeading = styled.div`
  font: normal normal normal 22px/30px Segoe UI;
`;

export { Organization };
